import dayjs, { type Dayjs } from 'dayjs';

export const formatMonthDay = (date: Dayjs): string =>
  new Intl.DateTimeFormat(dayjs.locale(), { month: 'short', day: '2-digit' }).format(date.toDate());
